<template>
  <v-app dark  :key="componentKey">
    <SideBar :key="$i18n.locale + '0'" v-on:reload="switchLanguage($event)" v-if="this.$session.exists()"></SideBar>
    <v-content class="content" dark :key=$i18n.locale>
          <router-view/>
    </v-content>
  </v-app>
</template>

<script>
import SideBar from '@/components/sideBar'

export default {
  name: 'App',
  components: {
    SideBar
  },
  data () {
    return {
      logged: false,
      selectedBrands: 1,
      brands: [
        {
          name: 'Armani',
          value: 1
        },
        {
          name: 'YSL',
          value: 2
        }
      ],
      componentKey: 0,
      langs: ['fr', 'en'],
      currentLang: 'en'
    }
  },
  methods: {
    switchLanguage (value) {
      this.$i18n.locale = value
      this.$forceUpdate()
    }
  },
  mounted () {
    if (!this.$session.exists()) localStorage.clear()
    else if (!localStorage.isLogged) this.$session.destroy()
    else this.logged = true
  },
  created () {
    this.selectedBrands = localStorage.brand
    this.$vuetify.theme.dark = true
  }
}
</script>

<style>
a {
  text-decoration: none;
}
.content{
  /* background-color: black;
  color:white; */
  margin-top: 75px;
}
</style>
